<template>
  <section id="education" class="resume-section">
    <div class="resume-section-content">
      <h2 class="mb-5"> {{ education }} </h2>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">{{ title }}</h3>
          <div class="subheading mb-3">{{ description }}</div>
          <div class="mt-4">
            <h4>{{ courseTitle }}</h4>
            <ul>
              <li v-for="(course, index) in courses" :key="'course-' + index">{{ course }}</li>
            </ul>
          </div>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">{{ date }}</span></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    courses() {
      return this.$i18n.messages[this.$i18n.locale].education.courses;
    },
    education() {
      return this.$t('sections.education')
    },
    title() {
      return this.$t('education.title')
    },
    description() {
      return this.$t('education.description')
    },
    courseTitle() {
      return this.$t('education.coursesTitle')
    },
    date() {
      return this.$t('education.duration')
    }
  }
};
</script>
